import { useState, useMemo } from "react";
import Button from "react-bootstrap/Button";
import { CONTENT_SLOT_CONTENT_TYPE_OPTIONS, EXPLICIT_CONSENT_CONTENT_TYPE_OPTION } from "@constants/content-slot-content-type-options";
import { resources } from "@constants/hardcoded-strings";
import { AXNUIFormContentSlotContentTypes } from "@iddataweb/idw-common-ui/enums";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { SelectOption } from "@idw-types/common";
import { SelectFormGroup } from "@containers/common/select-form-group/select-form-group";

type FormContentSlotContentTypeSelectContainerProps = {
    formContentSlotType: string;
    isDisabled: boolean;
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    order: Array<AXNUIFormContentSlotContentTypes>;
    setOrder: (order: Array<AXNUIFormContentSlotContentTypes>) => void;
};

type FormContentSlotContentTypeSelectContainerState = {
    selectedContentSlotContentType: SelectOption;
};

export const FormContentSlotContentTypeSelectContainer = (props: FormContentSlotContentTypeSelectContainerProps) => {
    const { formContentSlotType, isDisabled, layout, labelWidth, order, setOrder } = props;

    const [state, setState] = useState<FormContentSlotContentTypeSelectContainerState>({
        selectedContentSlotContentType: CONTENT_SLOT_CONTENT_TYPE_OPTIONS[0]
    });

    const handleContentSlotContentTypeChange = (newValue: SelectOption) => {
        setState({
            ...state,
            selectedContentSlotContentType: newValue as any
        });
    };

    const handleSetOrder = () => {
        if (state.selectedContentSlotContentType && !order.includes(state.selectedContentSlotContentType.value as AXNUIFormContentSlotContentTypes)) {
            const newOrder = [...order];
            newOrder.push(state.selectedContentSlotContentType.value as AXNUIFormContentSlotContentTypes);
            setOrder(newOrder);
        }
    };

    const contentSlotContentTypeOptions = useMemo(() => {
        if (formContentSlotType === "post-form-content-slot") {
            return [...CONTENT_SLOT_CONTENT_TYPE_OPTIONS, EXPLICIT_CONSENT_CONTENT_TYPE_OPTION];
        } else {
            return CONTENT_SLOT_CONTENT_TYPE_OPTIONS;
        }
    }, [formContentSlotType, CONTENT_SLOT_CONTENT_TYPE_OPTIONS]);

    return (
        <div>
            <SelectFormGroup
                controlId={`theming-${formContentSlotType}-content-type-select-input`}
                automationId={`theming-${formContentSlotType}-content-type-select-input`}
                label={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.contentType.label}
                ariaLabel={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.contentType.label}
                disabled={isDisabled}
                isClearable={false}
                isRequired={false}
                isSearchable={false}
                layout={layout}
                labelWidth={labelWidth}
                onChange={handleContentSlotContentTypeChange}
                options={contentSlotContentTypeOptions}
                selectedOption={state.selectedContentSlotContentType}
            />
            <Button
                disabled={isDisabled}
                onClick={handleSetOrder}>
                {resources.pages.verificationServiceDetails.tabs.theming.subTabs.preFormContentSlot.buttons.add.label}
            </Button>
        </div>
    );
}